export default __webpack_public_path__ + "static/media/fees@2x.2b49d985.svg";